<template>
	<div
		v-if="!fixedOpen"
		class="accordion"
		:class="[
			{ 'accordion--large': large },
			{ 'accordion--small': small },
			{ 'accordion--open': show },
			{ 'accordion--white': lightTheme },
			{ 'accordion--blue': blueTheme },
			{ 'accordion--dark-blue': darkBlueTheme }
		]"
	>
		<button
			:class="[
				'accordion__head',
				{ 'accordion__head--white': lightTheme },
				{ 'accordion__head--blue': blueTheme },
				{ 'accordion__head--dark-blue': darkBlueTheme },
				{ disabled: disabled }
			]"
			@click="sendToggleStatus"
		>
			<div class="accordion__head__left">
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-if="iconType == 'calendar'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M22 2H2a1 1 0 00-1 1v18a1 1 0 001 1h20a1 1 0 001-1V3a1 1 0 00-1-1zM6.75 20H3v-3h3.75zm0-4H3v-3h3.75zm0-4H3V9h3.75zm4.75 8H7.75v-3h3.75zm0-4H7.75v-3h3.75zm0-4H7.75V9h3.75zm4.75 8H12.5v-3h3.75zm0-4H12.5v-3h3.75zm0-4H12.5V9h3.75zM21 20h-3.75v-3H21zm0-4h-3.75v-3H21zm0-4h-3.75V9H21zm0-5H3V4h18z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-else-if="iconType == 'people'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M9.38 14.06L9.19 14a7.09 7.09 0 003-6 5.07 5.07 0 00-5-5 5.07 5.07 0 00-5 5 7.11 7.11 0 003 6l-.19.09C1 15.86-.8 17.31.21 20.35a1 1 0 001 .68h12a1 1 0 00.95-.68c1.02-3.07-.81-4.52-4.78-6.29zM4.22 8a3 3 0 013-3 3 3 0 013 3c0 2.07-.89 3.59-3 4.92-2.1-1.33-3-2.85-3-4.92zm8.23 11H2c-.08-.8.5-1.61 3.88-3.11.47-.22.92-.43 1.34-.66.42.23.87.44 1.35.66 3.43 1.5 3.96 2.31 3.88 3.11z"/><path d="M18.81 14.7a6.31 6.31 0 002.56-5.2 4.54 4.54 0 00-9.07 0c0 2.64 1.25 4.59 4 6.18h.06c.49.28 1 .55 1.61.81 2.73 1.2 3.34 1.86 3.36 2.48h-4.5a1 1 0 000 2h5.3a1 1 0 00.95-.68c.92-2.7-.79-4.06-4.27-5.59zm-2-1c-2.19-1.41-2.54-2.82-2.54-4.16a2.54 2.54 0 015.07 0 4.64 4.64 0 01-2.5 4.12z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-else-if="iconType == 'location'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M11.5 6.32a2.88 2.88 0 102.88 2.88 2.89 2.89 0 00-2.88-2.88zm0 4.6a1.73 1.73 0 111.73-1.72 1.73 1.73 0 01-1.73 1.72z"/><path d="M11.5 1.15A7.49 7.49 0 004 8.62c0 3.9 2.76 9.2 6.71 12.89l.79.73.79-.73c3.95-3.69 6.71-9 6.71-12.89a7.49 7.49 0 00-7.5-7.47zm0 17.9c-3.41-3.53-5.19-7.82-5.19-10.43a5.19 5.19 0 0110.38 0c0 2.61-1.78 6.9-5.19 10.43z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-else-if="iconType == 'facilities'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M16 16h-5a1 1 0 000 2h5a1 1 0 000-2zM8.38 12.07a1 1 0 00-1.09.22 1 1 0 000 1.42 1.15 1.15 0 00.33.21A1 1 0 009 13a1.05 1.05 0 00-.29-.71 1.46 1.46 0 00-.33-.22zM8.38 16.07a1 1 0 00-1.09.22 1 1 0 00-.21 1.09.9.9 0 00.54.54 1 1 0 001.09-.21 1.15 1.15 0 00.21-.33A1 1 0 009 17a1.05 1.05 0 00-.29-.71 1.46 1.46 0 00-.33-.22zM8.38 8.07a1 1 0 00-1.09.22 1 1 0 000 1.42 1.15 1.15 0 00.33.21A1 1 0 009 9a1.05 1.05 0 00-.29-.71 1.46 1.46 0 00-.33-.22z"/><path d="M18 2h-1V1a1 1 0 00-2 0v1h-2V1a1 1 0 00-2 0v1H9V1a1 1 0 00-2 0v1H6a3 3 0 00-3 3v15a3 3 0 003 3h12a3 3 0 003-3V5a3 3 0 00-3-3zm1 18a1 1 0 01-1 1H6a1 1 0 01-1-1V5a1 1 0 011-1h1v1a1 1 0 002 0V4h2v1a1 1 0 002 0V4h2v1a1 1 0 002 0V4h1a1 1 0 011 1z"/><path d="M16 12h-5a1 1 0 000 2h5a1 1 0 000-2zM16 8h-5a1 1 0 000 2h5a1 1 0 000-2z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-else-if="iconType == 'campaigncode'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M15.49 8.43a.45.45 0 00-.19-.33.5.5 0 00-.7.1l-6 8a.5.5 0 00.1.7.47.47 0 00.3.1.52.52 0 00.4-.2l6-8a.49.49 0 00.09-.37zM11.17 10.5a2 2 0 10-2 2 2 2 0 002-2zm-3 0a1 1 0 111 1 1 1 0 01-1-1z"/><path d="M22.78 11.87L20.94 9.6l.15-2.92a1 1 0 00-.74-1l-2.82-.78-1.6-2.45a1 1 0 00-1.2-.39L12 3.1l-2.73-1a1 1 0 00-1.2.39L6.47 4.9l-2.82.76a1 1 0 00-.74 1l.15 2.94-1.84 2.27a1 1 0 000 1.26l1.84 2.27-.15 2.92a1 1 0 00.74 1l2.82.76 1.6 2.45a1 1 0 001.2.38l2.73-1 2.73 1a.89.89 0 00.36.07 1 1 0 00.84-.45l1.6-2.45 2.82-.76a1 1 0 00.74-1l-.15-2.92 1.84-2.27a1 1 0 000-1.26zm-3.63 2.57a1 1 0 00-.22.68l.12 2.5-2.41.65a1 1 0 00-.58.42l-1.37 2.09-2.33-.89a1 1 0 00-.72 0l-2.33.89-1.37-2.09a1 1 0 00-.58-.42L5 17.62l.12-2.5a1 1 0 00-.22-.68L3.28 12.5l1.57-1.95a.92.92 0 00.22-.67L5 7.38l2.41-.65A1 1 0 008 6.31l1.31-2.09 2.33.89a1 1 0 00.72 0l2.33-.89 1.37 2.09a1 1 0 00.58.42l2.41.65-.12 2.5a1 1 0 00.22.67l1.57 1.95z"/><path d="M15.17 12.5a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 111-1 1 1 0 01-1 1z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-else-if="iconType == 'search'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M16.62 15.13A6.9 6.9 0 0018 11a7 7 0 10-2.77 5.56l4.35 4.35L21 19.5zM11 16a5 5 0 115-5 5 5 0 01-5 5z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-else-if="iconType == 'accommodation'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M45.84 71.5h2a1 1 0 000-2h-2a1 1 0 000 2zM57.84 84.5h-16a1 1 0 000 2h16a1 1 0 000-2z"/><path class="cls-1" d="M67.84 33.55v-15a1 1 0 00-1-1h-7a1 1 0 00-1 1v6.05L52.32 18a3.59 3.59 0 00-5 0L21 44.37a3.51 3.51 0 104.94 5l2.87-2.87v4.08a3.48 3.48 0 000 6.94v3.06a3.48 3.48 0 000 6.94v3.06a3.48 3.48 0 000 6.94v3h-4a1 1 0 000 2h50a1 1 0 000-2h-4v-3a3.48 3.48 0 000-6.94v-3.11a3.48 3.48 0 000-6.94v-3.06a3.48 3.48 0 000-6.94v-4.08l2.87 2.87a3.52 3.52 0 104.95-5zm-7-14h5v12l-5-5zm-19 61h-11v-3h11zm0-5H29.09a1.5 1.5 0 010-3h12.75zm0-5h-11v-3h11zm0-5H29.09a1.5 1.5 0 010-3h12.75zm14 15h-12v-19h12zm1-21h-14a1 1 0 00-1 1h-11v-3h38v3h-11a1 1 0 00-1-1zm1 8h11v3h-11zm11 13h-11v-3h11zM72.09 74a1.5 1.5 0 01-1.5 1.5H57.84v-3h12.75a1.5 1.5 0 011.5 1.5zm0-10a1.5 1.5 0 01-1.5 1.5H57.84v-3h12.75a1.5 1.5 0 011.5 1.5zm0-10a1.5 1.5 0 01-1.5 1.5h-41.5a1.5 1.5 0 010-3h41.5a1.5 1.5 0 011.5 1.5zm-34.25-8.5h-7v-1l1.95-2h5.05a1 1 0 000-2h-3.05l8-8h6.52a1 1 0 000-2h-4.52l5.05-5.05 15.06 15h-3.06a1 1 0 000 2h5.06l1.94 2v1h-7a1 1 0 000 2h7v3h-11v-12a1 1 0 00-1-1h-14a1 1 0 00-1 1v12h-11v-3h7a1 1 0 000-2zm13-1.5v-4.5h5V44zm5 2v4.5h-5V46zm-12-2v-4.5h5v4.55zm5 2v4.5h-5V46zm28.41 1.9a1.5 1.5 0 01-2.12 0L68 40.79 50.55 23.33a1 1 0 00-1.41 0l-7.47 7.46L24.56 47.9a1.5 1.5 0 11-2.12-2.12l26.34-26.34a1.5 1.5 0 012.13 0l26.34 26.34a1.51 1.51 0 010 2.12zM85.34 2h-9a3.52 3.52 0 00-3.5 3.5v2a1.5 1.5 0 01-1.5 1.5h-5a3.52 3.52 0 00-3.5 3.5v2a1 1 0 002 0v-2a1.5 1.5 0 011.5-1.5h5a3.5 3.5 0 003.5-3.5v-2a1.5 1.5 0 011.5-1.5h9a1 1 0 000-2z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-else-if="iconType == 'skipass'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M38.45 72.23h1v7.36h-1zM45.22 72.23h3v7.36h-3zM41.04 72.23h1v7.36h-1zM30.98 72.23h3v7.36h-3zM37 57.72a3.7 3.7 0 00-1.79-.37h-4.28v9.34h1.92v-3.11h2.34a3.55 3.55 0 001.81-.39 1.9 1.9 0 00.85-1.06 5.89 5.89 0 00.21-1.67 5.47 5.47 0 00-.22-1.71 1.79 1.79 0 00-.84-1.03zm-1 3.68a.66.66 0 01-.46.4 4.19 4.19 0 01-1.17.11h-1.52V59h1.58a4.52 4.52 0 011.16.11.63.63 0 01.45.39 3.31 3.31 0 01.1.94 2.83 2.83 0 01-.14.96zM35.86 72.23h1v7.36h-1zM56.58 72.23h1v7.36h-1zM61.64 62.31a3 3 0 001.38.47L65 63a1.64 1.64 0 01.54.13.46.46 0 01.22.27 2.81 2.81 0 010 .58 2.44 2.44 0 010 .54.57.57 0 01-.22.33 1.2 1.2 0 01-.58.21 6.52 6.52 0 01-1.08.06c-.78 0-1.73-.06-2.85-.16v1.61a23 23 0 003.42.22 6.81 6.81 0 001.8-.2 1.85 1.85 0 001-.84 3.55 3.55 0 00.41-1.94 3.84 3.84 0 00-.32-1.8 1.4 1.4 0 00-.64-.61 3.86 3.86 0 00-1-.25l-2.15-.25a2.55 2.55 0 01-.61-.13.36.36 0 01-.24-.25 1.94 1.94 0 01-.06-.59 1.57 1.57 0 01.06-.53.44.44 0 01.27-.28 4 4 0 011.61-.21 19.55 19.55 0 012.65.18v-1.57a14.38 14.38 0 00-3-.28 8 8 0 00-1.89.19 2 2 0 00-1.16.81 3.11 3.11 0 00-.44 1.81 4.24 4.24 0 00.26 1.37 1.7 1.7 0 00.64.89zM66.95 72.23h1v7.36h-1zM59.18 72.23h1v7.36h-1z"/><path class="cls-1" d="M73.63 54.13V20.42a4 4 0 00-4-4H56l5-11a1 1 0 00-1.8-.84l-5.44 11.84h-8.9L39.43 4.58a1 1 0 00-.82-.58 1 1 0 00-.91.42 1 1 0 00-.09 1l5 11H29a4 4 0 00-4 4v61.35a4 4 0 004 4h40.63a4 4 0 004-4V54.65a1.14 1.14 0 000-.52zM27 20.42a2 2 0 012-2h14.58l2.84 6.17a4.92 4.92 0 101.81-.84l-2.45-5.33h23.85a2 2 0 012 2v31.51L59 39.33a1 1 0 00-.71-.29 1 1 0 00-.7.29L51.9 45 40.2 33.34a1 1 0 00-1.42 0L27 45.12zm23.22 7.67l-1.12-2.45h.21a2.89 2.89 0 11-2 .84l1.09 2.44a1 1 0 00.91.58 1 1 0 00.42-.09 1 1 0 00.49-1.32zm21.41 53.67a2 2 0 01-.58 1.42 2 2 0 01-1.42.59H29a2 2 0 01-2-2V48l12.49-12.54 16.78 16.78a1 1 0 101.42-1.42l-4.37-4.36 5-5 13.31 13.3z"/><path class="cls-1" d="M50.11 72.23h1v7.36h-1zM42.88 57.35l-3.16 9.34h1.94l.67-2H46l.68 2h2l-3.17-9.34zm0 5.65l1.26-3.83h.07L45.45 63zM62.06 72.23h3v7.36h-3zM53.99 72.23h1v7.36h-1zM56.94 61.4a3.86 3.86 0 00-1-.25l-2.15-.25a2.55 2.55 0 01-.61-.13.42.42 0 01-.24-.25 2.32 2.32 0 010-.59 1.87 1.87 0 010-.53.53.53 0 01.27-.28 4 4 0 011.62-.21 19.41 19.41 0 012.64.18v-1.57a14.38 14.38 0 00-3-.28 8 8 0 00-1.88.19 2 2 0 00-1.17.81 3.11 3.11 0 00-.42 1.81 4.54 4.54 0 00.19 1.37 1.7 1.7 0 00.67.89 3.24 3.24 0 001.38.47l2 .23a1.64 1.64 0 01.54.13.46.46 0 01.22.27 2.32 2.32 0 010 .59 2.44 2.44 0 010 .54.64.64 0 01-.23.33 1.2 1.2 0 01-.58.21 6.34 6.34 0 01-1.07.06c-.79 0-1.74-.06-2.85-.16v1.61a23 23 0 003.42.22 6.74 6.74 0 001.79-.2 1.84 1.84 0 001.1-.85 3.73 3.73 0 00.4-1.94 3.84 3.84 0 00-.32-1.8 1.46 1.46 0 00-.72-.62z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-else-if="iconType == 'skischool'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M45.64 22a.45.45 0 00.25.07.5.5 0 00.26-.93 9.16 9.16 0 00-5.82-1 .49.49 0 00-.45.54.48.48 0 00.54.45 8.19 8.19 0 015.22.87z"/><path class="cls-1" d="M83.41 83a1 1 0 00-1.4.17c-2.6 3.33-7.17 3.43-10.32 2.11l-16.26-6.9a5.38 5.38 0 001.42-3.08 3.23 3.23 0 00-1.25-2.46 3.81 3.81 0 01-1-1.26c-.34-.81.56-2.29 1.05-2.88 3.15-3.82 5-7.06 3.85-10.45s-4-5-9.24-7.58C48.9 50 48 49 48 48.18a4.73 4.73 0 011.66-2.25l2.58 1.47a7.22 7.22 0 003.35 4.6 36.54 36.54 0 0012.08 4.45 9.44 9.44 0 003.66.84 4.54 4.54 0 003.4-1.3 3.22 3.22 0 00.59-3.68 3.94 3.94 0 00-2.18-1.91 2 2 0 00-.71-1.59c-1.07-.88-2.9-.67-4.92.55-2.29-1.11-5.32-2.51-6.71-3.15a33.86 33.86 0 00.53-9.48 2.88 2.88 0 00.36-.61 3 3 0 00.16-1.82 8.61 8.61 0 001.64.16 7.75 7.75 0 007.74-7.75v-.36a1.1 1.1 0 00.35-.11 1 1 0 00.48-.74 7 7 0 00-1.56-5.68c-1.57-1.78-4.19-2.76-7.37-2.76-4.81 0-8.31 3.91-8.31 9.31a5.64 5.64 0 00.08.93 54.88 54.88 0 01-3.47-4.93c-2.62-4.11-6.21-5.84-11-5.31a1 1 0 10.23 2c4-.45 6.81.9 9 4.39 3.53 5.52 5.77 8 9.24 10.14.9.56 1.1 1.28.9 1.75a1 1 0 01-1.3.45c-2.14-.57-6-4.35-8.49-8.25-3.43-5.42-7.88-5.49-9.63-5.26a1 1 0 10.25 2c2.91-.38 5.71 1.21 7.69 4.35l.28.42A21.4 21.4 0 0039 32.1l-6.79-6.45 1.87-2a1 1 0 00-1.48-1.35l-1.84 2-2.34-2.23A1 1 0 1027 23.5l2.37 2.25-2 2.21a1 1 0 00.74 1.67 1 1 0 00.74-.32l2-2.18 6.48 6.16a20.17 20.17 0 00-2.19 2.07l-9.9-5.63 1.32-2.44a1 1 0 00-1.76-.95l-1.3 2.4-2.82-1.6a1 1 0 00-1.36.37 1 1 0 00.38 1.37l2.84 1.62-1.42 2.62a1 1 0 00.4 1.36 1.07 1.07 0 00.48.12 1 1 0 00.88-.52l1.4-2.59 9.55 5.43-.24.31A19.75 19.75 0 0030.22 46a1 1 0 00.24.75 1 1 0 00.7.35l1.77.11c-.2 3.42.87 6.54 2.88 8.14 2.72 2.17 7.33 4.12 10.55 5.4A2.09 2.09 0 0147.71 62a3.36 3.36 0 01-.54 2.63c-.76 1.23-4.17 5.26-6.17 7.65l-.86-.36-27.75-11.73a1 1 0 10-.78 1.81c.56.23 55.78 23.58 59.31 25a12.35 12.35 0 004.73.94 9.79 9.79 0 007.93-3.66 1 1 0 00-.17-1.28zM52.06 45l-.64-.37c.23-.13.46-.27.71-.4-.03.26-.05.52-.07.77zm18 7c2-.08 3.09.58 3.44 1.27a1.23 1.23 0 01-.25 1.42c-.61.64-2 1-4.1.28zM58.85 29.22a2.71 2.71 0 01-2.05-2.82c0-4.31 2.6-7.31 6.31-7.31 2.6 0 4.68.74 5.87 2.09a4.59 4.59 0 011.13 2.94.88.88 0 00-.28 0 19.34 19.34 0 00-2.52-.2c-3.11 0-6.25 1.54-6.59 5a3.46 3.46 0 01-1.87.3zm1 2a6.47 6.47 0 002.41-.84 1 1 0 00.46-.85c0-3.5 4.15-3.6 4.62-3.6a18 18 0 011.88.13 5.17 5.17 0 010 .68 5.76 5.76 0 01-5.74 5.75 5.36 5.36 0 01-3.66-1.27zM50 31c2.41 3.13 5.59 6.14 8 6.79a3.51 3.51 0 001 .13 2.86 2.86 0 00.42 0 33.45 33.45 0 01-.73 8.74 1 1 0 00.55 1.15c.07 0 6 2.74 8.78 4.14l-.77 2.51a34.8 34.8 0 01-10.58-4c-1.9-1.21-4.1-3.57-1.35-10.08a1 1 0 10-1.84-.77 19.67 19.67 0 00-.84 2.35 13 13 0 00-3.16 1.69L36.9 36.38C40.21 32.92 44.2 31.3 50 31zM32.38 45.19a17.13 17.13 0 012.78-6.76c.13-.18.27-.34.4-.51l12.29 7A7.59 7.59 0 0046.29 47c-1.48-.31-4.54-.91-7.6-1.25-2.54-.29-4.96-.47-6.31-.56zM47.1 58.91c-2-.78-7.24-2.87-10-5.1-1.16-.93-2.34-3.14-2.13-6.42 1.07.09 2.29.21 3.53.35 3.13.35 6.32 1 7.66 1.27a5.85 5.85 0 003.31 3.46c4.88 2.38 7.27 3.65 8.23 6.44.82 2.38-.54 4.85-3.08 8l-5.4-1.73a5.08 5.08 0 00.44-3.75 4.06 4.06 0 00-2.56-2.52zm6.39 18.65L42.93 73.1c1.31-1.54 3.72-4.41 5.09-6.21l5.33 1.72a4.39 4.39 0 00-.54 3.75 5.66 5.66 0 001.39 1.9c.48.48.65.66.65 1a4.72 4.72 0 01-1.36 2.3z"/><path class="cls-1" d="M66.07 28.77a.88.88 0 00.12.21.7.7 0 00.15.19 1.24 1.24 0 001.77 0 1 1 0 00.16-.19 1.39 1.39 0 00.11-.21 1.09 1.09 0 00.07-.24 1 1 0 000-.48 1.09 1.09 0 00-.07-.24 1.39 1.39 0 00-.11-.21 1.56 1.56 0 00-.16-.2l-.19-.15a.91.91 0 00-.22-.11.9.9 0 00-.23-.08 1.35 1.35 0 00-.49 0 .9.9 0 00-.23.08.91.91 0 00-.22.11l-.19.15a1 1 0 00-.15.2.88.88 0 00-.12.21 2.17 2.17 0 00-.07.24 1.45 1.45 0 000 .48 2.17 2.17 0 00.07.24z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-else-if="iconType == 'skirental'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M80 77.11a1 1 0 00-.73-.28h-.91v-4.56c0-2.23-1.15-3.75-3.61-4.8a34.35 34.35 0 01-4-2.39C68.62 63.69 66 62 62.52 60l-.81-.45a1 1 0 000-.72 5.58 5.58 0 00-2.29-2.47c-1.87-1.32-3.06-1-3.28-.94a1.06 1.06 0 00-.33.18l-.08.08-.12-.1a.7.7 0 00.08-.2 4.78 4.78 0 00-.64-2.66c-.75-1.49-1.42-1.9-1.76-2a4.27 4.27 0 002.66-2h.26a1 1 0 00.68-.28A4.42 4.42 0 0058 46.17a5.05 5.05 0 00.11-2.32 1 1 0 00-.6-.68l.75-3.61h.12a1 1 0 00.54-.16c.41-.26 1-1 1.27-3a5.64 5.64 0 000-2.94 1 1 0 00-.58-.54c.38-1.94.64-3.29.64-3.29a.9.9 0 000-.4l3-9.73-1.06-.23a23.21 23.21 0 00-8.06 0 10 10 0 00-6 3.29 37.82 37.82 0 01-3.8-3.69 12.52 12.52 0 00-6.17-3.7l-.74-.17-.36.67a35.48 35.48 0 00-2.13 4.85 20.75 20.75 0 00-.82 4.42 6.64 6.64 0 00-2.11-.41h-.88l-.12.89s-.65 6-1.54 14.31c-.69 6.52-1.46 8.64-2.58 11.56-.29.76-.6 1.58-.93 2.54C24.34 58.51 23.1 64 23.09 64l-.09.45.23.36s.3.45.71 1A9.73 9.73 0 0024 71a12.81 12.81 0 001 2.53 1 1 0 00-.93 1v5.3c0 .1.53 2.33 4 2.33H40a1 1 0 00.35-.06 26.72 26.72 0 018.38-1.1 87.66 87.66 0 0110.1 1 90.38 90.38 0 0010.77 1 30.55 30.55 0 0010-1.44 1 1 0 00.65-.94v-2.79a1 1 0 00-.25-.72zM61.54 61.77c2.94 1.65 5.29 3.14 7.22 4.41-.89 1-2 1.32-3.86 1.21a65.62 65.62 0 01-7.82-1.93c.16-.25.32-.49.47-.7 1.12-1.56 2.13-2.79 2.85-3.63zm-4.63-4.4a3.48 3.48 0 011.4.66 6.5 6.5 0 011.22 1 54 54 0 00-3.6 4.52 73.18 73.18 0 00-5.3 9.92L49.37 73a46.51 46.51 0 013.34-9.74 22.38 22.38 0 014.2-5.89zm-2.83-.49l.3.27a25.37 25.37 0 00-3.46 5.29c-.18.36-.34.72-.51 1.07-1.15-.33-2.21-.64-3.1-.88a6.3 6.3 0 01-2.09-1 71.14 71.14 0 008.86-4.75zm-.78-3.23a4.59 4.59 0 01.4 1.09 66.28 66.28 0 01-11.4 5.92 70.16 70.16 0 01-10.52 3.21l-.31-1.35c1.82-.51 6-1.72 9.53-3.07 4-1.51 9.91-5.21 11.9-6.48a5.77 5.77 0 01.4.68zm-12.42 3.69l-.59.24c-.69.26-1.39.52-2.11.76a8.17 8.17 0 010-3.93 5.53 5.53 0 013.5-3.89c-.28 1.24-.51 2.33-.66 3.16a12.47 12.47 0 00-.14 3.66zm7.07-9a1 1 0 00-1 .21 1 1 0 00-.28 1 1 1 0 00.76.71 15.48 15.48 0 003.88.68 3.26 3.26 0 00.05.67c-1.79 1.12-5.38 3.33-8.53 4.88a10.22 10.22 0 01.11-2.49c.25-1.4.74-3.54 1.31-6l.26-1.13c3 .66 6.62 1.2 9.08 1.53-.88.6-2.46.81-5.59-.08zm8.1-2.56a4.53 4.53 0 01-.32.94h-.32a108.62 108.62 0 01-12.79-2.24c-3.33-1-6.55-2-8-2.45l.23-1.73c1.58.47 4.65 1.36 8.2 2.3A133 133 0 0056.18 45a6.35 6.35 0 01-.13.76zm-.52-2.91c-2.35-.35-6.35-1-9.74-1.75.25-1.19.46-2.25.63-3.23h.23c3.5.62 7.21 1.12 9.61 1.41-.26 1.26-.5 2.47-.73 3.55zm2.69-6.74a7.42 7.42 0 01-.34 1.39h-.31c-1.79-.21-6.4-.78-10.57-1.52s-9.36-1.79-11.44-2.22l.27-1.78c2.22.45 7.63 1.43 11.83 1.88s8.83.8 10.68.94a9.38 9.38 0 01-.12 1.29zM54.4 21.26a23.15 23.15 0 016.22-.18l-2.18 7.13-3.28-.88a31.64 31.64 0 01-5.57-3.51 8 8 0 014.81-2.56zm3.68 9c-.12.62-.3 1.51-.51 2.58-2.18-.17-6.08-.48-9.7-.87-1-.11-2.07-.24-3.15-.4a2 2 0 01.17-1.43 5.48 5.48 0 014.46-2c1.19.08 5.92 1.32 8.73 2.09zm-21.26-9.11a31 31 0 011.63-3.8 10.51 10.51 0 014.28 2.85 41.1 41.1 0 006.5 5.86 7.43 7.43 0 00-6 3 3.71 3.71 0 00-.51 2.16L41.51 31a11.48 11.48 0 00-4.6-4.84l-.86-.43a21.61 21.61 0 01.77-4.58zm-9 33.33c.33-.94.63-1.74.91-2.49 1.15-3.06 2-5.27 2.7-12 .67-6.27 1.2-11.21 1.43-13.27A14.07 14.07 0 0136 27.93a8.64 8.64 0 012.89 2.62c-2.12-.37-3.62-.66-3.66-.67a1 1 0 00-.76.16 1 1 0 00-.42.66l-.59 3.64a1 1 0 00.78 1.14c.06 0 5.32 1.11 10.24 2-.17.94-.37 2-.61 3.13l-.27-.07C38.47 39.22 34.35 38 34.31 38a1 1 0 00-.83.12 1 1 0 00-.45.71l-.49 3.71a1 1 0 00.67 1.08s4.36 1.38 8.86 2.68l.49.13-.26 1.14-.15.67a7.9 7.9 0 00-5.95 5.65 10.06 10.06 0 00.09 5.11C33 60.06 30.07 60.83 30 60.84a1 1 0 00-.69 1.16l.69 3.26a1 1 0 001 .79h.17a61.45 61.45 0 007.06-1.82c.2.46.41.9.58 1.33 1.08 2.54.59 5-1.2 6s-5.06.32-7.37-1.47a31.88 31.88 0 01-5.12-6c.34-1.38 1.4-5.77 2.72-9.61zM69.6 81a90.44 90.44 0 01-10.52-1 87.57 87.57 0 00-10.35-1 29.4 29.4 0 00-8.9 1.13H28c-1.49 0-1.9-.55-2-.7v-3.9h.9a1 1 0 00.93-.66 1 1 0 00-.3-1.11 7.2 7.2 0 01-1.61-3.3 8.1 8.1 0 01-.29-2.35A21.48 21.48 0 0029 71.68a11.38 11.38 0 006.57 2.37 6.06 6.06 0 003-.76c2.65-1.57 3.48-5.08 2-8.53-.16-.38-.34-.78-.53-1.18.92-.32 1.88-.67 2.88-1.06l.15-.06a7.75 7.75 0 003.6 2.1l2.85.81a49.38 49.38 0 00-2.4 8.17 1 1 0 00.64 1.12l3 1a1 1 0 00.34.06 1 1 0 00.91-.59 88.62 88.62 0 014-8 59 59 0 008.75 2.16h.74a5.93 5.93 0 005-2.13 24.86 24.86 0 003.46 2c2.1.89 2.39 2 2.39 3v5.68a46.65 46.65 0 01-6.88.61 75.15 75.15 0 01-9.23-.81 79.48 79.48 0 00-16.81-.85.52.52 0 00-.46.54.49.49 0 00.17.34.52.52 0 00.37.12 78.16 78.16 0 0116.6.84 75.31 75.31 0 009.36.82 48.35 48.35 0 007.78-.75h1v1.12A31.79 31.79 0 0169.6 81z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-else-if="iconType == 'activities'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M22.46 21a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm-6.86 4.39l3.47 2a1 1 0 01.36 1.37 1 1 0 01-1.36.36l-3.47-2a1 1 0 011-1.73zm15.09.37a1 1 0 01-.37 1.36l-3.46 2a1 1 0 01-.5.14 1 1 0 01-.5-1.87l3.46-2a1 1 0 011.37.37zM53 27.52a1 1 0 011.4-.18l2.6 2a1 1 0 01-.61 1.79 1 1 0 01-.6-.2l-2.61-2a1 1 0 01-.18-1.41zm-26.14 4.37l3.46 2a1 1 0 01-.5 1.87 1 1 0 01-.5-.14l-3.46-2a1 1 0 111-1.73zm-7.43.37a1 1 0 01-.36 1.36l-3.47 2a1 1 0 01-.5.14 1 1 0 01-.5-1.87l3.47-2a1 1 0 011.36.37zm40.08.24a1 1 0 011.41-.18l2.6 2a1 1 0 01.18 1.4 1 1 0 01-.79.39 1 1 0 01-.61-.2l-2.6-2a1 1 0 01-.19-1.41zM22.46 34a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm26 5.49l-.91 2.78a1 1 0 01-1 .69H43.7l2.36 1.72a1 1 0 01.37 1.12l-.91 2.78 2.37-1.72a1 1 0 01.59-.19 1 1 0 01.59.19l2.36 1.72-.9-2.78a1 1 0 01.36-1.12L53.26 43h-2.93a1 1 0 01-.95-.69zm0-4.24a1 1 0 011 .69l1.63 5h5.28a1 1 0 01.58 1.81l-4.26 3.1 1.63 5a1 1 0 01-.4 1.15 1 1 0 01-1.17 0l-4.27-3.11L44.21 52A1 1 0 0143 52a1 1 0 01-.36-1.12l1.63-5-4.27-3.1a1 1 0 01-.36-1.12 1 1 0 01.95-.69h5.31l1.63-5a1 1 0 01.95-.71zm29.08 25.22a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zM53.31 15.6l-5.26 6.87 2.46 1.88a1 1 0 01.18 1.4 1 1 0 01-.79.4 1 1 0 01-.61-.21l-2.46-1.88-21.19 27.68 6.29 4.81a5.92 5.92 0 019.26 7.09l6.28 4.81 21.19-27.68-2.45-1.88a1 1 0 01-.21-1.41 1 1 0 011.4-.18l2.46 1.88 5.26-6.87-6.27-4.81a5.91 5.91 0 01-7.62.36 5.94 5.94 0 01-1.64-7.45zm17.37 49.26l3.46 2a1 1 0 01.37 1.36 1 1 0 01-.87.5 1 1 0 01-.5-.13l-3.46-2a1 1 0 111-1.73zm15.09.36a1 1 0 01-.37 1.37l-3.47 2a1 1 0 01-1.36-.37 1 1 0 01.36-1.36l3.47-2a1 1 0 011.37.36zm-3.83 6.14l3.46 2a1 1 0 01.36 1.36 1 1 0 01-.86.5 1 1 0 01-.5-.13l-3.46-2a1 1 0 111-1.73zm-7.43.36a1 1 0 01-.37 1.37l-3.46 2a1 1 0 01-.5.13 1 1 0 01-.5-1.86l3.46-2a1 1 0 011.37.36zm3 1.75a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011.03-1zm-9.2-28.95L48.46 70.46a1.05 1.05 0 01-.67.39h-.13a1 1 0 01-.61-.2l-7.8-6a1 1 0 01-.19-1.4 3.92 3.92 0 00-.73-5.49 3.92 3.92 0 00-5.49.73 1 1 0 01-1.4.19l-.51-.39-7.2 9.41L30 72.53a5.92 5.92 0 019.26 7.09l6.28 4.81 21.21-27.69-2.46-1.88a1 1 0 01-.18-1.4 1 1 0 011.4-.19L68 55.15l5.25-6.86zM53 13.21a1 1 0 01.74.2l7.8 6a1 1 0 01.19 1.4A3.91 3.91 0 0065.34 27a3.92 3.92 0 002.6-1.5 1 1 0 01.66-.38 1 1 0 01.74.2l7.81 6a1 1 0 01.18 1.4l-6.47 8.46-1.34 1.74 5.71 4.38a1 1 0 01.19 1.4L69 57.16 46.54 86.44a1 1 0 01-.66.38h-.13a1 1 0 01-.61-.21l-7.8-6a1 1 0 01-.19-1.4 3.92 3.92 0 10-6.22-4.76 1 1 0 01-1.4.18l-7.81-6a1 1 0 01-.18-1.4l7.81-10.2-5.71-4.38a1 1 0 01-.19-1.4l28.88-37.66a1 1 0 01.67-.38z"/></svg>
				<div class="accordion-titles">
					<p v-if="subTitle != ''" class="small small--color-lynch">
						{{ subTitle }}
						<span v-if="required === true" class="label-required">*</span>
					</p>
					<h4>
						{{ title }}
						<span v-if="titleParanthesis != ''">({{ titleParanthesis }})</span>
						<slot name="unpaid"></slot>
					</h4>
					<span v-if="errorMessage" class="accordion__error-message colorRed">
						{{ errorMessage }}
					</span>
					<slot name="booking"></slot>
				</div>
			</div>

			<div
				v-if="
					large === false &&
					blueTheme === false &&
					darkBlueTheme === false &&
					disabled == false
				"
				:class="[
					'accordion__head__right',
					{ 'accordion__head__right--large': largeSvg }
				]"
			>
				<svg width="14" height="2" viewBox="0 0 14 2" xmlns="http://www.w3.org/2000/svg" v-if="show === true" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M0 2V0h14v2z" fill-rule="evenodd"/></svg>
				<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M6.055 14V7.925H0V6.04h6.055V0h1.82v6.04H14v1.885H7.875V14z" fill-rule="evenodd"/></svg>
			</div>
			<div
				v-else-if="darkBlueTheme === true"
				:class="[
					'accordion__head__right',
					{ 'accordion__head__right--large': largeSvg }
				]"
			>
				<svg width="10" height="15" viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg" v-if="show === true" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M.697 7.89L7.767.817l1.415 1.414L3.526 7.89l5.656 5.657-1.414 1.414-5.656-5.657H2.11L.697 7.89z" fill="#fff" fill-rule="evenodd"/></svg>
				<svg width="10" height="15" viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M.697 7.89L7.767.817l1.415 1.414L3.526 7.89l5.656 5.657-1.414 1.414-5.656-5.657H2.11L.697 7.89z" fill="#fff" fill-rule="evenodd"/></svg>
			</div>
			<div
				v-else-if="disabled == false"
				:class="[
					'accordion__head__right',
					{ 'accordion__head__right--large': largeSvg }
				]"
			>
				<div v-if="errorSum" class="error-sum">
					{{ errorSum }}
				</div>
				<svg width="14" height="2" viewBox="0 0 14 2" xmlns="http://www.w3.org/2000/svg" v-if="show === true" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M0 2V0h14v2z" fill-rule="evenodd"/></svg>
				<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:class="'icon arrow-down'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M6.055 14V7.925H0V6.04h6.055V0h1.82v6.04H14v1.885H7.875V14z" fill-rule="evenodd"/></svg>
			</div>
		</button>

		<transition-accordion>
			<div
				:class="['accordion__body', { 'accordion__body--white': lightTheme }]"
				v-if="show"
			>
				<div class="accordion__body-inner">
					<slot></slot>
				</div>

				<button
					v-show="showFooter"
					type="button"
					:class="['accordion__foot']"
					@click="sendToggleStatus"
				>
					<span>Dölj boenden</span>
					<svg width="14" height="2" viewBox="0 0 14 2" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M0 2V0h14v2z" fill-rule="evenodd"/></svg>
				</button>
			</div>
		</transition-accordion>
	</div>

	<div
		v-else
		class="accordion"
		:class="[{ 'accordion--large': large }, { 'accordion--open': show }]"
	>
		<div class="accordion__head" @click="sendToggleStatus">
			<div class="accordion__head__left accordion__head__left--fixed">
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-if="iconType == 'calendar'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M22 2H2a1 1 0 00-1 1v18a1 1 0 001 1h20a1 1 0 001-1V3a1 1 0 00-1-1zM6.75 20H3v-3h3.75zm0-4H3v-3h3.75zm0-4H3V9h3.75zm4.75 8H7.75v-3h3.75zm0-4H7.75v-3h3.75zm0-4H7.75V9h3.75zm4.75 8H12.5v-3h3.75zm0-4H12.5v-3h3.75zm0-4H12.5V9h3.75zM21 20h-3.75v-3H21zm0-4h-3.75v-3H21zm0-4h-3.75V9H21zm0-5H3V4h18z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-else-if="iconType == 'people'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M9.38 14.06L9.19 14a7.09 7.09 0 003-6 5.07 5.07 0 00-5-5 5.07 5.07 0 00-5 5 7.11 7.11 0 003 6l-.19.09C1 15.86-.8 17.31.21 20.35a1 1 0 001 .68h12a1 1 0 00.95-.68c1.02-3.07-.81-4.52-4.78-6.29zM4.22 8a3 3 0 013-3 3 3 0 013 3c0 2.07-.89 3.59-3 4.92-2.1-1.33-3-2.85-3-4.92zm8.23 11H2c-.08-.8.5-1.61 3.88-3.11.47-.22.92-.43 1.34-.66.42.23.87.44 1.35.66 3.43 1.5 3.96 2.31 3.88 3.11z"/><path d="M18.81 14.7a6.31 6.31 0 002.56-5.2 4.54 4.54 0 00-9.07 0c0 2.64 1.25 4.59 4 6.18h.06c.49.28 1 .55 1.61.81 2.73 1.2 3.34 1.86 3.36 2.48h-4.5a1 1 0 000 2h5.3a1 1 0 00.95-.68c.92-2.7-.79-4.06-4.27-5.59zm-2-1c-2.19-1.41-2.54-2.82-2.54-4.16a2.54 2.54 0 015.07 0 4.64 4.64 0 01-2.5 4.12z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-else-if="iconType == 'location'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M11.5 6.32a2.88 2.88 0 102.88 2.88 2.89 2.89 0 00-2.88-2.88zm0 4.6a1.73 1.73 0 111.73-1.72 1.73 1.73 0 01-1.73 1.72z"/><path d="M11.5 1.15A7.49 7.49 0 004 8.62c0 3.9 2.76 9.2 6.71 12.89l.79.73.79-.73c3.95-3.69 6.71-9 6.71-12.89a7.49 7.49 0 00-7.5-7.47zm0 17.9c-3.41-3.53-5.19-7.82-5.19-10.43a5.19 5.19 0 0110.38 0c0 2.61-1.78 6.9-5.19 10.43z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-else-if="iconType == 'facilities'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M16 16h-5a1 1 0 000 2h5a1 1 0 000-2zM8.38 12.07a1 1 0 00-1.09.22 1 1 0 000 1.42 1.15 1.15 0 00.33.21A1 1 0 009 13a1.05 1.05 0 00-.29-.71 1.46 1.46 0 00-.33-.22zM8.38 16.07a1 1 0 00-1.09.22 1 1 0 00-.21 1.09.9.9 0 00.54.54 1 1 0 001.09-.21 1.15 1.15 0 00.21-.33A1 1 0 009 17a1.05 1.05 0 00-.29-.71 1.46 1.46 0 00-.33-.22zM8.38 8.07a1 1 0 00-1.09.22 1 1 0 000 1.42 1.15 1.15 0 00.33.21A1 1 0 009 9a1.05 1.05 0 00-.29-.71 1.46 1.46 0 00-.33-.22z"/><path d="M18 2h-1V1a1 1 0 00-2 0v1h-2V1a1 1 0 00-2 0v1H9V1a1 1 0 00-2 0v1H6a3 3 0 00-3 3v15a3 3 0 003 3h12a3 3 0 003-3V5a3 3 0 00-3-3zm1 18a1 1 0 01-1 1H6a1 1 0 01-1-1V5a1 1 0 011-1h1v1a1 1 0 002 0V4h2v1a1 1 0 002 0V4h2v1a1 1 0 002 0V4h1a1 1 0 011 1z"/><path d="M16 12h-5a1 1 0 000 2h5a1 1 0 000-2zM16 8h-5a1 1 0 000 2h5a1 1 0 000-2z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-else-if="iconType == 'campaigncode'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M15.49 8.43a.45.45 0 00-.19-.33.5.5 0 00-.7.1l-6 8a.5.5 0 00.1.7.47.47 0 00.3.1.52.52 0 00.4-.2l6-8a.49.49 0 00.09-.37zM11.17 10.5a2 2 0 10-2 2 2 2 0 002-2zm-3 0a1 1 0 111 1 1 1 0 01-1-1z"/><path d="M22.78 11.87L20.94 9.6l.15-2.92a1 1 0 00-.74-1l-2.82-.78-1.6-2.45a1 1 0 00-1.2-.39L12 3.1l-2.73-1a1 1 0 00-1.2.39L6.47 4.9l-2.82.76a1 1 0 00-.74 1l.15 2.94-1.84 2.27a1 1 0 000 1.26l1.84 2.27-.15 2.92a1 1 0 00.74 1l2.82.76 1.6 2.45a1 1 0 001.2.38l2.73-1 2.73 1a.89.89 0 00.36.07 1 1 0 00.84-.45l1.6-2.45 2.82-.76a1 1 0 00.74-1l-.15-2.92 1.84-2.27a1 1 0 000-1.26zm-3.63 2.57a1 1 0 00-.22.68l.12 2.5-2.41.65a1 1 0 00-.58.42l-1.37 2.09-2.33-.89a1 1 0 00-.72 0l-2.33.89-1.37-2.09a1 1 0 00-.58-.42L5 17.62l.12-2.5a1 1 0 00-.22-.68L3.28 12.5l1.57-1.95a.92.92 0 00.22-.67L5 7.38l2.41-.65A1 1 0 008 6.31l1.31-2.09 2.33.89a1 1 0 00.72 0l2.33-.89 1.37 2.09a1 1 0 00.58.42l2.41.65-.12 2.5a1 1 0 00.22.67l1.57 1.95z"/><path d="M15.17 12.5a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 111-1 1 1 0 01-1 1z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-else-if="iconType == 'search'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M16.62 15.13A6.9 6.9 0 0018 11a7 7 0 10-2.77 5.56l4.35 4.35L21 19.5zM11 16a5 5 0 115-5 5 5 0 01-5 5z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-else-if="iconType == 'accommodation'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M45.84 71.5h2a1 1 0 000-2h-2a1 1 0 000 2zM57.84 84.5h-16a1 1 0 000 2h16a1 1 0 000-2z"/><path class="cls-1" d="M67.84 33.55v-15a1 1 0 00-1-1h-7a1 1 0 00-1 1v6.05L52.32 18a3.59 3.59 0 00-5 0L21 44.37a3.51 3.51 0 104.94 5l2.87-2.87v4.08a3.48 3.48 0 000 6.94v3.06a3.48 3.48 0 000 6.94v3.06a3.48 3.48 0 000 6.94v3h-4a1 1 0 000 2h50a1 1 0 000-2h-4v-3a3.48 3.48 0 000-6.94v-3.11a3.48 3.48 0 000-6.94v-3.06a3.48 3.48 0 000-6.94v-4.08l2.87 2.87a3.52 3.52 0 104.95-5zm-7-14h5v12l-5-5zm-19 61h-11v-3h11zm0-5H29.09a1.5 1.5 0 010-3h12.75zm0-5h-11v-3h11zm0-5H29.09a1.5 1.5 0 010-3h12.75zm14 15h-12v-19h12zm1-21h-14a1 1 0 00-1 1h-11v-3h38v3h-11a1 1 0 00-1-1zm1 8h11v3h-11zm11 13h-11v-3h11zM72.09 74a1.5 1.5 0 01-1.5 1.5H57.84v-3h12.75a1.5 1.5 0 011.5 1.5zm0-10a1.5 1.5 0 01-1.5 1.5H57.84v-3h12.75a1.5 1.5 0 011.5 1.5zm0-10a1.5 1.5 0 01-1.5 1.5h-41.5a1.5 1.5 0 010-3h41.5a1.5 1.5 0 011.5 1.5zm-34.25-8.5h-7v-1l1.95-2h5.05a1 1 0 000-2h-3.05l8-8h6.52a1 1 0 000-2h-4.52l5.05-5.05 15.06 15h-3.06a1 1 0 000 2h5.06l1.94 2v1h-7a1 1 0 000 2h7v3h-11v-12a1 1 0 00-1-1h-14a1 1 0 00-1 1v12h-11v-3h7a1 1 0 000-2zm13-1.5v-4.5h5V44zm5 2v4.5h-5V46zm-12-2v-4.5h5v4.55zm5 2v4.5h-5V46zm28.41 1.9a1.5 1.5 0 01-2.12 0L68 40.79 50.55 23.33a1 1 0 00-1.41 0l-7.47 7.46L24.56 47.9a1.5 1.5 0 11-2.12-2.12l26.34-26.34a1.5 1.5 0 012.13 0l26.34 26.34a1.51 1.51 0 010 2.12zM85.34 2h-9a3.52 3.52 0 00-3.5 3.5v2a1.5 1.5 0 01-1.5 1.5h-5a3.52 3.52 0 00-3.5 3.5v2a1 1 0 002 0v-2a1.5 1.5 0 011.5-1.5h5a3.5 3.5 0 003.5-3.5v-2a1.5 1.5 0 011.5-1.5h9a1 1 0 000-2z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-else-if="iconType == 'skipass'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M38.45 72.23h1v7.36h-1zM45.22 72.23h3v7.36h-3zM41.04 72.23h1v7.36h-1zM30.98 72.23h3v7.36h-3zM37 57.72a3.7 3.7 0 00-1.79-.37h-4.28v9.34h1.92v-3.11h2.34a3.55 3.55 0 001.81-.39 1.9 1.9 0 00.85-1.06 5.89 5.89 0 00.21-1.67 5.47 5.47 0 00-.22-1.71 1.79 1.79 0 00-.84-1.03zm-1 3.68a.66.66 0 01-.46.4 4.19 4.19 0 01-1.17.11h-1.52V59h1.58a4.52 4.52 0 011.16.11.63.63 0 01.45.39 3.31 3.31 0 01.1.94 2.83 2.83 0 01-.14.96zM35.86 72.23h1v7.36h-1zM56.58 72.23h1v7.36h-1zM61.64 62.31a3 3 0 001.38.47L65 63a1.64 1.64 0 01.54.13.46.46 0 01.22.27 2.81 2.81 0 010 .58 2.44 2.44 0 010 .54.57.57 0 01-.22.33 1.2 1.2 0 01-.58.21 6.52 6.52 0 01-1.08.06c-.78 0-1.73-.06-2.85-.16v1.61a23 23 0 003.42.22 6.81 6.81 0 001.8-.2 1.85 1.85 0 001-.84 3.55 3.55 0 00.41-1.94 3.84 3.84 0 00-.32-1.8 1.4 1.4 0 00-.64-.61 3.86 3.86 0 00-1-.25l-2.15-.25a2.55 2.55 0 01-.61-.13.36.36 0 01-.24-.25 1.94 1.94 0 01-.06-.59 1.57 1.57 0 01.06-.53.44.44 0 01.27-.28 4 4 0 011.61-.21 19.55 19.55 0 012.65.18v-1.57a14.38 14.38 0 00-3-.28 8 8 0 00-1.89.19 2 2 0 00-1.16.81 3.11 3.11 0 00-.44 1.81 4.24 4.24 0 00.26 1.37 1.7 1.7 0 00.64.89zM66.95 72.23h1v7.36h-1zM59.18 72.23h1v7.36h-1z"/><path class="cls-1" d="M73.63 54.13V20.42a4 4 0 00-4-4H56l5-11a1 1 0 00-1.8-.84l-5.44 11.84h-8.9L39.43 4.58a1 1 0 00-.82-.58 1 1 0 00-.91.42 1 1 0 00-.09 1l5 11H29a4 4 0 00-4 4v61.35a4 4 0 004 4h40.63a4 4 0 004-4V54.65a1.14 1.14 0 000-.52zM27 20.42a2 2 0 012-2h14.58l2.84 6.17a4.92 4.92 0 101.81-.84l-2.45-5.33h23.85a2 2 0 012 2v31.51L59 39.33a1 1 0 00-.71-.29 1 1 0 00-.7.29L51.9 45 40.2 33.34a1 1 0 00-1.42 0L27 45.12zm23.22 7.67l-1.12-2.45h.21a2.89 2.89 0 11-2 .84l1.09 2.44a1 1 0 00.91.58 1 1 0 00.42-.09 1 1 0 00.49-1.32zm21.41 53.67a2 2 0 01-.58 1.42 2 2 0 01-1.42.59H29a2 2 0 01-2-2V48l12.49-12.54 16.78 16.78a1 1 0 101.42-1.42l-4.37-4.36 5-5 13.31 13.3z"/><path class="cls-1" d="M50.11 72.23h1v7.36h-1zM42.88 57.35l-3.16 9.34h1.94l.67-2H46l.68 2h2l-3.17-9.34zm0 5.65l1.26-3.83h.07L45.45 63zM62.06 72.23h3v7.36h-3zM53.99 72.23h1v7.36h-1zM56.94 61.4a3.86 3.86 0 00-1-.25l-2.15-.25a2.55 2.55 0 01-.61-.13.42.42 0 01-.24-.25 2.32 2.32 0 010-.59 1.87 1.87 0 010-.53.53.53 0 01.27-.28 4 4 0 011.62-.21 19.41 19.41 0 012.64.18v-1.57a14.38 14.38 0 00-3-.28 8 8 0 00-1.88.19 2 2 0 00-1.17.81 3.11 3.11 0 00-.42 1.81 4.54 4.54 0 00.19 1.37 1.7 1.7 0 00.67.89 3.24 3.24 0 001.38.47l2 .23a1.64 1.64 0 01.54.13.46.46 0 01.22.27 2.32 2.32 0 010 .59 2.44 2.44 0 010 .54.64.64 0 01-.23.33 1.2 1.2 0 01-.58.21 6.34 6.34 0 01-1.07.06c-.79 0-1.74-.06-2.85-.16v1.61a23 23 0 003.42.22 6.74 6.74 0 001.79-.2 1.84 1.84 0 001.1-.85 3.73 3.73 0 00.4-1.94 3.84 3.84 0 00-.32-1.8 1.46 1.46 0 00-.72-.62z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-else-if="iconType == 'skischool'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M45.64 22a.45.45 0 00.25.07.5.5 0 00.26-.93 9.16 9.16 0 00-5.82-1 .49.49 0 00-.45.54.48.48 0 00.54.45 8.19 8.19 0 015.22.87z"/><path class="cls-1" d="M83.41 83a1 1 0 00-1.4.17c-2.6 3.33-7.17 3.43-10.32 2.11l-16.26-6.9a5.38 5.38 0 001.42-3.08 3.23 3.23 0 00-1.25-2.46 3.81 3.81 0 01-1-1.26c-.34-.81.56-2.29 1.05-2.88 3.15-3.82 5-7.06 3.85-10.45s-4-5-9.24-7.58C48.9 50 48 49 48 48.18a4.73 4.73 0 011.66-2.25l2.58 1.47a7.22 7.22 0 003.35 4.6 36.54 36.54 0 0012.08 4.45 9.44 9.44 0 003.66.84 4.54 4.54 0 003.4-1.3 3.22 3.22 0 00.59-3.68 3.94 3.94 0 00-2.18-1.91 2 2 0 00-.71-1.59c-1.07-.88-2.9-.67-4.92.55-2.29-1.11-5.32-2.51-6.71-3.15a33.86 33.86 0 00.53-9.48 2.88 2.88 0 00.36-.61 3 3 0 00.16-1.82 8.61 8.61 0 001.64.16 7.75 7.75 0 007.74-7.75v-.36a1.1 1.1 0 00.35-.11 1 1 0 00.48-.74 7 7 0 00-1.56-5.68c-1.57-1.78-4.19-2.76-7.37-2.76-4.81 0-8.31 3.91-8.31 9.31a5.64 5.64 0 00.08.93 54.88 54.88 0 01-3.47-4.93c-2.62-4.11-6.21-5.84-11-5.31a1 1 0 10.23 2c4-.45 6.81.9 9 4.39 3.53 5.52 5.77 8 9.24 10.14.9.56 1.1 1.28.9 1.75a1 1 0 01-1.3.45c-2.14-.57-6-4.35-8.49-8.25-3.43-5.42-7.88-5.49-9.63-5.26a1 1 0 10.25 2c2.91-.38 5.71 1.21 7.69 4.35l.28.42A21.4 21.4 0 0039 32.1l-6.79-6.45 1.87-2a1 1 0 00-1.48-1.35l-1.84 2-2.34-2.23A1 1 0 1027 23.5l2.37 2.25-2 2.21a1 1 0 00.74 1.67 1 1 0 00.74-.32l2-2.18 6.48 6.16a20.17 20.17 0 00-2.19 2.07l-9.9-5.63 1.32-2.44a1 1 0 00-1.76-.95l-1.3 2.4-2.82-1.6a1 1 0 00-1.36.37 1 1 0 00.38 1.37l2.84 1.62-1.42 2.62a1 1 0 00.4 1.36 1.07 1.07 0 00.48.12 1 1 0 00.88-.52l1.4-2.59 9.55 5.43-.24.31A19.75 19.75 0 0030.22 46a1 1 0 00.24.75 1 1 0 00.7.35l1.77.11c-.2 3.42.87 6.54 2.88 8.14 2.72 2.17 7.33 4.12 10.55 5.4A2.09 2.09 0 0147.71 62a3.36 3.36 0 01-.54 2.63c-.76 1.23-4.17 5.26-6.17 7.65l-.86-.36-27.75-11.73a1 1 0 10-.78 1.81c.56.23 55.78 23.58 59.31 25a12.35 12.35 0 004.73.94 9.79 9.79 0 007.93-3.66 1 1 0 00-.17-1.28zM52.06 45l-.64-.37c.23-.13.46-.27.71-.4-.03.26-.05.52-.07.77zm18 7c2-.08 3.09.58 3.44 1.27a1.23 1.23 0 01-.25 1.42c-.61.64-2 1-4.1.28zM58.85 29.22a2.71 2.71 0 01-2.05-2.82c0-4.31 2.6-7.31 6.31-7.31 2.6 0 4.68.74 5.87 2.09a4.59 4.59 0 011.13 2.94.88.88 0 00-.28 0 19.34 19.34 0 00-2.52-.2c-3.11 0-6.25 1.54-6.59 5a3.46 3.46 0 01-1.87.3zm1 2a6.47 6.47 0 002.41-.84 1 1 0 00.46-.85c0-3.5 4.15-3.6 4.62-3.6a18 18 0 011.88.13 5.17 5.17 0 010 .68 5.76 5.76 0 01-5.74 5.75 5.36 5.36 0 01-3.66-1.27zM50 31c2.41 3.13 5.59 6.14 8 6.79a3.51 3.51 0 001 .13 2.86 2.86 0 00.42 0 33.45 33.45 0 01-.73 8.74 1 1 0 00.55 1.15c.07 0 6 2.74 8.78 4.14l-.77 2.51a34.8 34.8 0 01-10.58-4c-1.9-1.21-4.1-3.57-1.35-10.08a1 1 0 10-1.84-.77 19.67 19.67 0 00-.84 2.35 13 13 0 00-3.16 1.69L36.9 36.38C40.21 32.92 44.2 31.3 50 31zM32.38 45.19a17.13 17.13 0 012.78-6.76c.13-.18.27-.34.4-.51l12.29 7A7.59 7.59 0 0046.29 47c-1.48-.31-4.54-.91-7.6-1.25-2.54-.29-4.96-.47-6.31-.56zM47.1 58.91c-2-.78-7.24-2.87-10-5.1-1.16-.93-2.34-3.14-2.13-6.42 1.07.09 2.29.21 3.53.35 3.13.35 6.32 1 7.66 1.27a5.85 5.85 0 003.31 3.46c4.88 2.38 7.27 3.65 8.23 6.44.82 2.38-.54 4.85-3.08 8l-5.4-1.73a5.08 5.08 0 00.44-3.75 4.06 4.06 0 00-2.56-2.52zm6.39 18.65L42.93 73.1c1.31-1.54 3.72-4.41 5.09-6.21l5.33 1.72a4.39 4.39 0 00-.54 3.75 5.66 5.66 0 001.39 1.9c.48.48.65.66.65 1a4.72 4.72 0 01-1.36 2.3z"/><path class="cls-1" d="M66.07 28.77a.88.88 0 00.12.21.7.7 0 00.15.19 1.24 1.24 0 001.77 0 1 1 0 00.16-.19 1.39 1.39 0 00.11-.21 1.09 1.09 0 00.07-.24 1 1 0 000-.48 1.09 1.09 0 00-.07-.24 1.39 1.39 0 00-.11-.21 1.56 1.56 0 00-.16-.2l-.19-.15a.91.91 0 00-.22-.11.9.9 0 00-.23-.08 1.35 1.35 0 00-.49 0 .9.9 0 00-.23.08.91.91 0 00-.22.11l-.19.15a1 1 0 00-.15.2.88.88 0 00-.12.21 2.17 2.17 0 00-.07.24 1.45 1.45 0 000 .48 2.17 2.17 0 00.07.24z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-else-if="iconType == 'skirental'" v-bind:svg-inline="''" v-bind:ssrc="'../../assets/icons/illustrations/utrustning_100x100.svg'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M80 77.11a1 1 0 00-.73-.28h-.91v-4.56c0-2.23-1.15-3.75-3.61-4.8a34.35 34.35 0 01-4-2.39C68.62 63.69 66 62 62.52 60l-.81-.45a1 1 0 000-.72 5.58 5.58 0 00-2.29-2.47c-1.87-1.32-3.06-1-3.28-.94a1.06 1.06 0 00-.33.18l-.08.08-.12-.1a.7.7 0 00.08-.2 4.78 4.78 0 00-.64-2.66c-.75-1.49-1.42-1.9-1.76-2a4.27 4.27 0 002.66-2h.26a1 1 0 00.68-.28A4.42 4.42 0 0058 46.17a5.05 5.05 0 00.11-2.32 1 1 0 00-.6-.68l.75-3.61h.12a1 1 0 00.54-.16c.41-.26 1-1 1.27-3a5.64 5.64 0 000-2.94 1 1 0 00-.58-.54c.38-1.94.64-3.29.64-3.29a.9.9 0 000-.4l3-9.73-1.06-.23a23.21 23.21 0 00-8.06 0 10 10 0 00-6 3.29 37.82 37.82 0 01-3.8-3.69 12.52 12.52 0 00-6.17-3.7l-.74-.17-.36.67a35.48 35.48 0 00-2.13 4.85 20.75 20.75 0 00-.82 4.42 6.64 6.64 0 00-2.11-.41h-.88l-.12.89s-.65 6-1.54 14.31c-.69 6.52-1.46 8.64-2.58 11.56-.29.76-.6 1.58-.93 2.54C24.34 58.51 23.1 64 23.09 64l-.09.45.23.36s.3.45.71 1A9.73 9.73 0 0024 71a12.81 12.81 0 001 2.53 1 1 0 00-.93 1v5.3c0 .1.53 2.33 4 2.33H40a1 1 0 00.35-.06 26.72 26.72 0 018.38-1.1 87.66 87.66 0 0110.1 1 90.38 90.38 0 0010.77 1 30.55 30.55 0 0010-1.44 1 1 0 00.65-.94v-2.79a1 1 0 00-.25-.72zM61.54 61.77c2.94 1.65 5.29 3.14 7.22 4.41-.89 1-2 1.32-3.86 1.21a65.62 65.62 0 01-7.82-1.93c.16-.25.32-.49.47-.7 1.12-1.56 2.13-2.79 2.85-3.63zm-4.63-4.4a3.48 3.48 0 011.4.66 6.5 6.5 0 011.22 1 54 54 0 00-3.6 4.52 73.18 73.18 0 00-5.3 9.92L49.37 73a46.51 46.51 0 013.34-9.74 22.38 22.38 0 014.2-5.89zm-2.83-.49l.3.27a25.37 25.37 0 00-3.46 5.29c-.18.36-.34.72-.51 1.07-1.15-.33-2.21-.64-3.1-.88a6.3 6.3 0 01-2.09-1 71.14 71.14 0 008.86-4.75zm-.78-3.23a4.59 4.59 0 01.4 1.09 66.28 66.28 0 01-11.4 5.92 70.16 70.16 0 01-10.52 3.21l-.31-1.35c1.82-.51 6-1.72 9.53-3.07 4-1.51 9.91-5.21 11.9-6.48a5.77 5.77 0 01.4.68zm-12.42 3.69l-.59.24c-.69.26-1.39.52-2.11.76a8.17 8.17 0 010-3.93 5.53 5.53 0 013.5-3.89c-.28 1.24-.51 2.33-.66 3.16a12.47 12.47 0 00-.14 3.66zm7.07-9a1 1 0 00-1 .21 1 1 0 00-.28 1 1 1 0 00.76.71 15.48 15.48 0 003.88.68 3.26 3.26 0 00.05.67c-1.79 1.12-5.38 3.33-8.53 4.88a10.22 10.22 0 01.11-2.49c.25-1.4.74-3.54 1.31-6l.26-1.13c3 .66 6.62 1.2 9.08 1.53-.88.6-2.46.81-5.59-.08zm8.1-2.56a4.53 4.53 0 01-.32.94h-.32a108.62 108.62 0 01-12.79-2.24c-3.33-1-6.55-2-8-2.45l.23-1.73c1.58.47 4.65 1.36 8.2 2.3A133 133 0 0056.18 45a6.35 6.35 0 01-.13.76zm-.52-2.91c-2.35-.35-6.35-1-9.74-1.75.25-1.19.46-2.25.63-3.23h.23c3.5.62 7.21 1.12 9.61 1.41-.26 1.26-.5 2.47-.73 3.55zm2.69-6.74a7.42 7.42 0 01-.34 1.39h-.31c-1.79-.21-6.4-.78-10.57-1.52s-9.36-1.79-11.44-2.22l.27-1.78c2.22.45 7.63 1.43 11.83 1.88s8.83.8 10.68.94a9.38 9.38 0 01-.12 1.29zM54.4 21.26a23.15 23.15 0 016.22-.18l-2.18 7.13-3.28-.88a31.64 31.64 0 01-5.57-3.51 8 8 0 014.81-2.56zm3.68 9c-.12.62-.3 1.51-.51 2.58-2.18-.17-6.08-.48-9.7-.87-1-.11-2.07-.24-3.15-.4a2 2 0 01.17-1.43 5.48 5.48 0 014.46-2c1.19.08 5.92 1.32 8.73 2.09zm-21.26-9.11a31 31 0 011.63-3.8 10.51 10.51 0 014.28 2.85 41.1 41.1 0 006.5 5.86 7.43 7.43 0 00-6 3 3.71 3.71 0 00-.51 2.16L41.51 31a11.48 11.48 0 00-4.6-4.84l-.86-.43a21.61 21.61 0 01.77-4.58zm-9 33.33c.33-.94.63-1.74.91-2.49 1.15-3.06 2-5.27 2.7-12 .67-6.27 1.2-11.21 1.43-13.27A14.07 14.07 0 0136 27.93a8.64 8.64 0 012.89 2.62c-2.12-.37-3.62-.66-3.66-.67a1 1 0 00-.76.16 1 1 0 00-.42.66l-.59 3.64a1 1 0 00.78 1.14c.06 0 5.32 1.11 10.24 2-.17.94-.37 2-.61 3.13l-.27-.07C38.47 39.22 34.35 38 34.31 38a1 1 0 00-.83.12 1 1 0 00-.45.71l-.49 3.71a1 1 0 00.67 1.08s4.36 1.38 8.86 2.68l.49.13-.26 1.14-.15.67a7.9 7.9 0 00-5.95 5.65 10.06 10.06 0 00.09 5.11C33 60.06 30.07 60.83 30 60.84a1 1 0 00-.69 1.16l.69 3.26a1 1 0 001 .79h.17a61.45 61.45 0 007.06-1.82c.2.46.41.9.58 1.33 1.08 2.54.59 5-1.2 6s-5.06.32-7.37-1.47a31.88 31.88 0 01-5.12-6c.34-1.38 1.4-5.77 2.72-9.61zM69.6 81a90.44 90.44 0 01-10.52-1 87.57 87.57 0 00-10.35-1 29.4 29.4 0 00-8.9 1.13H28c-1.49 0-1.9-.55-2-.7v-3.9h.9a1 1 0 00.93-.66 1 1 0 00-.3-1.11 7.2 7.2 0 01-1.61-3.3 8.1 8.1 0 01-.29-2.35A21.48 21.48 0 0029 71.68a11.38 11.38 0 006.57 2.37 6.06 6.06 0 003-.76c2.65-1.57 3.48-5.08 2-8.53-.16-.38-.34-.78-.53-1.18.92-.32 1.88-.67 2.88-1.06l.15-.06a7.75 7.75 0 003.6 2.1l2.85.81a49.38 49.38 0 00-2.4 8.17 1 1 0 00.64 1.12l3 1a1 1 0 00.34.06 1 1 0 00.91-.59 88.62 88.62 0 014-8 59 59 0 008.75 2.16h.74a5.93 5.93 0 005-2.13 24.86 24.86 0 003.46 2c2.1.89 2.39 2 2.39 3v5.68a46.65 46.65 0 01-6.88.61 75.15 75.15 0 01-9.23-.81 79.48 79.48 0 00-16.81-.85.52.52 0 00-.46.54.49.49 0 00.17.34.52.52 0 00.37.12 78.16 78.16 0 0116.6.84 75.31 75.31 0 009.36.82 48.35 48.35 0 007.78-.75h1v1.12A31.79 31.79 0 0169.6 81z"/></svg>
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-else-if="iconType == 'activities'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M22.46 21a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm-6.86 4.39l3.47 2a1 1 0 01.36 1.37 1 1 0 01-1.36.36l-3.47-2a1 1 0 011-1.73zm15.09.37a1 1 0 01-.37 1.36l-3.46 2a1 1 0 01-.5.14 1 1 0 01-.5-1.87l3.46-2a1 1 0 011.37.37zM53 27.52a1 1 0 011.4-.18l2.6 2a1 1 0 01-.61 1.79 1 1 0 01-.6-.2l-2.61-2a1 1 0 01-.18-1.41zm-26.14 4.37l3.46 2a1 1 0 01-.5 1.87 1 1 0 01-.5-.14l-3.46-2a1 1 0 111-1.73zm-7.43.37a1 1 0 01-.36 1.36l-3.47 2a1 1 0 01-.5.14 1 1 0 01-.5-1.87l3.47-2a1 1 0 011.36.37zm40.08.24a1 1 0 011.41-.18l2.6 2a1 1 0 01.18 1.4 1 1 0 01-.79.39 1 1 0 01-.61-.2l-2.6-2a1 1 0 01-.19-1.41zM22.46 34a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm26 5.49l-.91 2.78a1 1 0 01-1 .69H43.7l2.36 1.72a1 1 0 01.37 1.12l-.91 2.78 2.37-1.72a1 1 0 01.59-.19 1 1 0 01.59.19l2.36 1.72-.9-2.78a1 1 0 01.36-1.12L53.26 43h-2.93a1 1 0 01-.95-.69zm0-4.24a1 1 0 011 .69l1.63 5h5.28a1 1 0 01.58 1.81l-4.26 3.1 1.63 5a1 1 0 01-.4 1.15 1 1 0 01-1.17 0l-4.27-3.11L44.21 52A1 1 0 0143 52a1 1 0 01-.36-1.12l1.63-5-4.27-3.1a1 1 0 01-.36-1.12 1 1 0 01.95-.69h5.31l1.63-5a1 1 0 01.95-.71zm29.08 25.22a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zM53.31 15.6l-5.26 6.87 2.46 1.88a1 1 0 01.18 1.4 1 1 0 01-.79.4 1 1 0 01-.61-.21l-2.46-1.88-21.19 27.68 6.29 4.81a5.92 5.92 0 019.26 7.09l6.28 4.81 21.19-27.68-2.45-1.88a1 1 0 01-.21-1.41 1 1 0 011.4-.18l2.46 1.88 5.26-6.87-6.27-4.81a5.91 5.91 0 01-7.62.36 5.94 5.94 0 01-1.64-7.45zm17.37 49.26l3.46 2a1 1 0 01.37 1.36 1 1 0 01-.87.5 1 1 0 01-.5-.13l-3.46-2a1 1 0 111-1.73zm15.09.36a1 1 0 01-.37 1.37l-3.47 2a1 1 0 01-1.36-.37 1 1 0 01.36-1.36l3.47-2a1 1 0 011.37.36zm-3.83 6.14l3.46 2a1 1 0 01.36 1.36 1 1 0 01-.86.5 1 1 0 01-.5-.13l-3.46-2a1 1 0 111-1.73zm-7.43.36a1 1 0 01-.37 1.37l-3.46 2a1 1 0 01-.5.13 1 1 0 01-.5-1.86l3.46-2a1 1 0 011.37.36zm3 1.75a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011.03-1zm-9.2-28.95L48.46 70.46a1.05 1.05 0 01-.67.39h-.13a1 1 0 01-.61-.2l-7.8-6a1 1 0 01-.19-1.4 3.92 3.92 0 00-.73-5.49 3.92 3.92 0 00-5.49.73 1 1 0 01-1.4.19l-.51-.39-7.2 9.41L30 72.53a5.92 5.92 0 019.26 7.09l6.28 4.81 21.21-27.69-2.46-1.88a1 1 0 01-.18-1.4 1 1 0 011.4-.19L68 55.15l5.25-6.86zM53 13.21a1 1 0 01.74.2l7.8 6a1 1 0 01.19 1.4A3.91 3.91 0 0065.34 27a3.92 3.92 0 002.6-1.5 1 1 0 01.66-.38 1 1 0 01.74.2l7.81 6a1 1 0 01.18 1.4l-6.47 8.46-1.34 1.74 5.71 4.38a1 1 0 01.19 1.4L69 57.16 46.54 86.44a1 1 0 01-.66.38h-.13a1 1 0 01-.61-.21l-7.8-6a1 1 0 01-.19-1.4 3.92 3.92 0 10-6.22-4.76 1 1 0 01-1.4.18l-7.81-6a1 1 0 01-.18-1.4l7.81-10.2-5.71-4.38a1 1 0 01-.19-1.4l28.88-37.66a1 1 0 01.67-.38z"/></svg>
				<div class="accordion-titles">
					<p v-if="subTitle != ''" class="small small--color-lynch">
						{{ subTitle }}
						<span v-if="required === true" class="label-required">*</span>
					</p>
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TransitionAccordion from '../atoms/TransitionAccordion'

export default {
	name: 'Accordion',
	components: {
		TransitionAccordion
	},
	props: {
		title: String,
		titleParanthesis: {
			type: String,
			default: ''
		},
		errorMessage: {
			type: String,
			default: ''
		},
		fixedOpen: {
			type: Boolean,
			default: false
		},
		subTitle: {
			type: String,
			default: ''
		},
		iconType: String,
		required: Boolean,
		show: Boolean,
		large: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		},
		lightTheme: {
			type: Boolean,
			default: false
		},
		blueTheme: {
			type: Boolean,
			default: false
		},
		darkBlueTheme: {
			type: Boolean,
			default: false
		},
		largeSvg: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		errorSum: {
			type: Number,
			default: 0
		},
		showFooter: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {}
	},
	methods: {
		sendToggleStatus() {
			this.$emit('toggle')
		}
	}
}
</script>

<style scoped lang="scss">
// Reset button styling
button {
	display: block;
	width: 100%;
	padding: 0;
	border: none;
	outline: none;
	font: inherit;
	color: inherit;
	background: none;
	text-align: left;
	&:hover &:focus {
		border: none;
	}
}

@include for-phone-only {
	.booking-dates .accordion__head {
		border-top: 0;
		&:hover {
			border-top: 0;
		}
	}
}

.accordion {
	width: 100%;
	@include for-desktop-up {
		margin-bottom: $spacing4 * 2;
	}

	.disabled {
		background-color: $colorGrey1;
		pointer-events: none;
		cursor: auto;
	}

	&__error-message {
		position: absolute;
		font-size: 12px;
		bottom: -15px;
		left: 0;
		right: 0;
		white-space: nowrap;
		width: 100%;
	}

	&__head {
		display: flex;
		justify-content: space-between;
		padding: $spacing4 0;
		border-top: 1px solid $colorPrimary1;
		background-color: $colorWhite;
		cursor: pointer;
		&:hover {
			border-top: 1px solid $colorPrimary1;
		}
		&:focus {
			border-top: 1px solid $colorPrimary1;
		}

		@include for-tablet-portrait-up {
			background-color: $colorGrey0;
			padding: $spacing4;
		}

		&__left {
			padding-right: $spacing3;
			display: flex;
			align-items: flex-end;

			svg {
				width: 25px;
				height: 25px;
				fill: $colorPrimary6;
				margin-bottom: 2px;
			}

			&--fixed {
				width: 100%;
				svg {
					margin-bottom: 30px;
				}

				.accordion-titles {
					width: 100%;
				}
			}

			> * {
				margin-left: 8px;

				@include for-tablet-portrait-up {
					margin-left: $spacing3;
				}

				&:first-child {
					margin-left: 0;
				}
			}

			> img {
				align-self: flex-end;
				margin-bottom: $spacing2;
			}

			.label-required {
				color: $colorDarkRed;
			}
		}

		&__right {
			align-self: center;
			margin-bottom: $spacing2;
			position: relative;

			> svg {
				fill: $colorSecondary9;
				width: 20px;
				height: 20px;

				&.arrow-down {
					transform: rotate(180deg);
				}
			}

			.error-sum {
				position: absolute;
				display: flex;
				justify-content: center;
				align-content: center;
				background-color: $colorRed;
				color: white;
				right: 40px;
				font-size: 13px;
				border-radius: 10px;
				width: 20px;
				height: 20px;
			}

			@include for-tablet-portrait-up {
				> svg {
					width: 12px;
					height: 12px;
					fill: $colorPrimary8;
				}
			}

			&--large {
				margin: 0;
				> svg {
					width: 20px;
					height: 24px;
				}
			}
		}

		&--white {
			border-top: 0;
			background-color: $colorWhite;
			padding: 20px;
			&:hover {
				border-top: 0;
			}
			&:focus {
				border-top: 0;
			}
			@include for-tablet-portrait-up {
				padding: 30px 40px;
			}
			// > .accordion__head {
				> .accordion__head__right {
					align-self: flex-start;
					margin-bottom: 0;
				}
				> .accordion__head__right > svg {
					width: 20px;
					height: 24px;
				}
			// }
		}

		&--blue {
			background-color: $colorSecondary;

			// > .accordion__head {
				> .accordion__head__right > svg {
					fill: #fff;
				}
			// }
		}

		&--dark-blue {
			background-color: $colorPrimary8;
			justify-content: center;
			padding: 15px 20px;

			// > .accordion__head {
				> .accordion__head__right {
					margin: 0;

					> svg {
						fill: #fff;
						transform: rotate(-90deg);
					}
				}
			// }
		}
	}

	&__foot {
		background-color: $colorSecondary;
		color: $colorWhite;
		font-size: 20px;
		letter-spacing: 0;
		line-height: 32px;
		padding: 20px;
		width: calc(100% + 40px);
		margin: 0 -20px;
		cursor: pointer;

		span {
			vertical-align: middle;
		}

		svg {
			fill: $colorWhite;
			margin-left: 10px;
			vertical-align: middle;
		}
	}

	&__body {
		background-color: $colorGrey0;
		// overflow: hidden;
		background-color: $colorWhite;
		@include for-desktop-up {
			background-color: $colorGrey0;
			//margin-top: $spacing4;
		}
		&-inner {
			padding: 20px;
			@include for-desktop-up {
				padding: $spacing4;
			}
		}

		&:first-child {
			margin-top: 0;
		}
		&--white {
			background-color: $colorWhite;
			padding: 0;
			.accordion__body-inner {
				padding-top: 0;
			}
			@include for-tablet-portrait-up {
				padding: 0 20px;
			}
		}
	}

	.accordion-titles {
		position: relative;
		p {
			font-size: 13px;
			line-break: 21px;
		}
		h4 {
			font-size: 20px;
			line-height: 26px;
		}
	}
	.accordion-titles > * {
		margin-top: $spacing1;

		&:first-child {
			margin-top: 0;
		}
	}

	.accordion-titles p {
		margin-bottom: 0;
	}

	&--white {
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;

		> .accordion__head {
			> .accordion__head__left {
				> .accordion-titles > h4 {
					color: $colorGrey8;
					font-size: 20px;
					letter-spacing: 0;
					line-height: 32px;
					@include for-tablet-portrait-up {
						font-size: 28px;
					}
				}
			}
		}

		h4 {
			display: flex;
			align-items: center;
		}
	}

	&--blue {
		> .accordion__head {
			> .accordion__head__left {
				> .accordion-titles > h4 {
					color: $colorWhite!important;
				}
			}
		}
	}

	&--white {
		> .accordion__head {
			> .accordion__head__left {
				> .accordion-titles > h4 {
					color: $colorGrey8;
				}
			}
		}
	}

	&--dark-blue {
		> .accordion__head {
			> .accordion__head__left {
				> .accordion-titles {
					text-align: center;
					> h4 {
						color: $colorWhite;
						font-size: 18px;
						line-height: 26px;
						font-weight: 300;
					}
				}
			}
		}
	}

	&--small {
		width: auto;
		border: 1px solid #7f8ba1;
		border-radius: 5px;
		max-width: 670px;

		> .accordion__head {
			background: none;
			padding: 10px;
			border: none;
			
			> .accordion__head__left {
				align-items: center;

				.accordion-titles h4 {
					font-size: 18px;
					line-height: 20px;
				}
			}

			> .accordion__head__right {
				margin-bottom: 0;
			}
		}

		> .accordion__body {
			background: none;

			> .accordion__body-inner {
				padding-bottom: 0;
				padding-top: 0;
			}
		}
	}

	&--large {
		@include for-desktop-up {
			margin-bottom: 0;
		}
		> .accordion__head {
			background: $colorWhite;
			padding: 12px 0;
			@include for-desktop-up {
				padding: 12px $spacing4;
			}
			border-color: $colorPrimary2;

			> .accordion__head__left {
				> svg {
					width: 56px;
					height: 56px;
					fill: $colorPrimary4;
					margin-bottom: 0;
				}

				> .accordion-titles {
					> h4 {
						font-size: 24px;
						line-height: 56px;
						color: $colorPrimary7;
						//font-weight: 400;
						font-weight: 500;
						> span {
							/*color: $colorPrimary4;
							font-weight: 300;*/
						}
					}
				}
			}
			
			> .accordion__head__right {
				> svg {
					width: 20px;
					height: 20px;
					fill: $colorSecondary;
				}
			}
		}

		> .accordion__body {
			background: $colorWhite;
			padding: 0;

			> .accordion__body-inner {
				padding: 0;
			}
		}

		&:last-child {
			border-bottom: 1px solid $colorPrimary2;
		}
	}

	&--open {
		&.accordion--large {
			> .accordion__head {
				&__left {
					> svg {
						fill: $colorPrimary;
					}
					.accordion-titles {
						> h4 {
							color: $colorPrimary;
							//font-weight: 500;
							> span {
								//color: $colorPrimary6;
							}
						}
					}
				}
				&__right {
					> svg {
						fill: $colorSecondary;
					}
				}
			}
			> .accordion__body {
			}
		}

		.accordion__head--dark-blue {
			background: $colorGrey8;

			> .accordion__head__right {
				> svg {
					fill: #fff;
					transform: rotate(90deg);
				}
			}
		}
	}
}

.filters {
	.accordion__body-inner {
		@include for-phone-only {
			padding: 0;
		}
	}
}
</style>
